module.exports = __webpack_public_path__ + "static/media/loadingStores.746900fa.gif";